import {
    Module, VuexModule, Mutation, Action
} from 'vuex-module-decorators';
import api from '@/api/notification';

@Module({ namespaced: true })
export default class extends VuexModule {

    @Action
    async categories(params: any) {
        return api.categories(params)
    }

    @Action
    async list(params: any) {
        return api.list(params);
    }

    @Action
    async detail(params: any) {
        return api.detail(params)
    }
}
